/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-api
 * crm-screener-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { ScreenerBedRoom } from './ScreenerBedRoom';
import {
    ScreenerBedRoomFromJSON,
    ScreenerBedRoomFromJSONTyped,
    ScreenerBedRoomToJSON,
} from './ScreenerBedRoom';

/**
 * 
 * @export
 * @interface BulkUpdateBedRoomsRequest
 */
export interface BulkUpdateBedRoomsRequest {
    /**
     * 
     * @type {Array<ScreenerBedRoom>}
     * @memberof BulkUpdateBedRoomsRequest
     */
    rooms: Array<ScreenerBedRoom>;
}

/**
 * Check if a given object implements the BulkUpdateBedRoomsRequest interface.
 */
export function instanceOfBulkUpdateBedRoomsRequest(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "rooms" in value;

    return isInstance;
}

export function BulkUpdateBedRoomsRequestFromJSON(json: any): BulkUpdateBedRoomsRequest {
    return BulkUpdateBedRoomsRequestFromJSONTyped(json, false);
}

export function BulkUpdateBedRoomsRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): BulkUpdateBedRoomsRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'rooms': ((json['rooms'] as Array<any>).map(ScreenerBedRoomFromJSON)),
    };
}

export function BulkUpdateBedRoomsRequestToJSON(value?: BulkUpdateBedRoomsRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'rooms': ((value.rooms as Array<any>).map(ScreenerBedRoomToJSON)),
    };
}

